/**
 * Shared Shepherd.js CSS theme for Lawis.
 * Supports light and dark modes using design tokens.
 */

const SHARED_CSS = `
  .shepherd-element {
    border-radius: 12px !important;
    max-width: 400px !important;
    font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif !important;
    z-index: 10000 !important;
  }
  .shepherd-content {
    padding: 0 !important;
  }
  .shepherd-header {
    background: transparent !important;
    padding: 20px 24px 0 24px !important;
    border-bottom: none !important;
  }
  .shepherd-title {
    font-size: 16px !important;
    font-weight: 600 !important;
    font-family: 'DM Sans', sans-serif !important;
  }
  .shepherd-text {
    font-size: 14px !important;
    line-height: 1.6 !important;
    padding: 12px 24px 20px 24px !important;
    font-family: 'DM Sans', sans-serif !important;
  }
  .shepherd-footer {
    padding: 0 24px 20px 24px !important;
    border-top: none !important;
    background: transparent !important;
  }
  .shepherd-button {
    border-radius: 8px !important;
    font-family: 'DM Sans', sans-serif !important;
    font-size: 13px !important;
    font-weight: 600 !important;
    padding: 8px 20px !important;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  .shepherd-button-primary {
    background-color: #c9a96e !important;
    color: #1c1917 !important;
    border: none !important;
  }
  .shepherd-button-primary:hover {
    background-color: #b8955a !important;
  }
  .shepherd-button-secondary {
    background-color: transparent !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
  }
  .shepherd-cancel-icon {
    font-size: 20px !important;
  }
  .shepherd-cancel-icon:hover {
    opacity: 1 !important;
  }
  .shepherd-has-title .shepherd-content .shepherd-header {
    background: transparent !important;
  }
  .shepherd-modal-overlay-container {
    fill: rgba(0, 0, 0, 0.55) !important;
  }
  .lawis-step-counter {
    display: inline-block;
    background: rgba(201, 169, 110, 0.15);
    color: #c9a96e;
    font-size: 11px;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 4px;
    margin-bottom: 8px;
  }
  .lawis-tour-progress {
    height: 3px;
    border-radius: 12px 12px 0 0;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }
  .lawis-tour-progress-bar {
    height: 100%;
    background: #c9a96e;
    transition: width 0.3s ease;
  }
`;

const DARK_CSS = `
  .shepherd-element {
    background: #1c1917 !important;
    border: 1px solid rgba(201, 169, 110, 0.3) !important;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5) !important;
  }
  .shepherd-title {
    color: #fff !important;
  }
  .shepherd-text {
    color: #a8a29e !important;
  }
  .shepherd-button-secondary {
    color: #a8a29e !important;
    border-color: rgba(255, 255, 255, 0.1) !important;
  }
  .shepherd-button-secondary:hover {
    color: #fff !important;
    border-color: rgba(255, 255, 255, 0.2) !important;
  }
  .shepherd-cancel-icon {
    color: #a8a29e !important;
  }
  .shepherd-cancel-icon:hover {
    color: #fff !important;
  }
  .shepherd-arrow::before {
    background: #1c1917 !important;
    border: 1px solid rgba(201, 169, 110, 0.3) !important;
  }
  .lawis-tour-progress {
    background: rgba(255, 255, 255, 0.05);
  }
`;

const LIGHT_CSS = `
  .shepherd-element {
    background: #ffffff !important;
    border: 1px solid #e7e5e4 !important;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08) !important;
  }
  .shepherd-title {
    color: #1c1917 !important;
  }
  .shepherd-text {
    color: #78716c !important;
  }
  .shepherd-button-secondary {
    color: #78716c !important;
    border-color: #e7e5e4 !important;
  }
  .shepherd-button-secondary:hover {
    color: #1c1917 !important;
    border-color: #d6d3d1 !important;
  }
  .shepherd-cancel-icon {
    color: #a8a29e !important;
  }
  .shepherd-cancel-icon:hover {
    color: #1c1917 !important;
  }
  .shepherd-arrow::before {
    background: #ffffff !important;
    border: 1px solid #e7e5e4 !important;
  }
  .lawis-tour-progress {
    background: rgba(0, 0, 0, 0.04);
  }
`;

let injectedStyleEl = null;

/**
 * Inject (or update) the Shepherd tour CSS for the given theme mode.
 * @param {'light'|'dark'} mode
 */
export function injectTourTheme(mode = 'dark') {
  const css = SHARED_CSS + (mode === 'dark' ? DARK_CSS : LIGHT_CSS);

  if (injectedStyleEl) {
    injectedStyleEl.textContent = css;
  } else {
    injectedStyleEl = document.createElement('style');
    injectedStyleEl.setAttribute('data-lawis-tour-theme', 'true');
    injectedStyleEl.textContent = css;
    document.head.appendChild(injectedStyleEl);
  }
}
